<template>
  <div
    class="
      tw-flex
      tw-h-full
      tw-items-center
      tw-justify-center
      tw-rounded-lg
      tw-bg-white
    "
    data-testid="document-preview-unreadable"
  >
    <div
      class="
        tw-flex
        tw-h-64
        tw-w-[30rem]
        tw-max-w-full
        tw-flex-col
        tw-items-center
        tw-justify-center
        tw-gap-6
        tw-rounded-lg
        tw-border
        tw-border-sf-slate-lighter-1
        tw-bg-sf-slate-subtle-1
        tw-p-6
      "
    >
      <i class="fa fa-envelope tw-text-5xl tw-text-sf-slate-light-2" />
      <span
        class="
          tw-text-center
          tw-text-base
          tw-font-normal
          tw-leading-[1.4]
          tw-text-sf-slate-light-2
        "
      >
        {{ I18n.t('permanent_document.error.email_extraction') }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'

const I18n = useI18n()
</script>
